import React from 'react'
import MaterialSymbol from '../material-symbol'

const CheckBox = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="check_box" {...props} />
))

CheckBox.displayName = 'CheckBox'

export default CheckBox
